const UPDATE_SLATES_KEY = 'update-slates';
export const getUpdateSlatesKey = () => UPDATE_SLATES_KEY;
//# sourceMappingURL=slate.keys.js.map